//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from '~/modules/dayjs'
import RequestOfferForm from '~/components/form/user/request-offer-form'
import OurBenefits from '~/components/content/our-benefits'
import Card from '~/components/UserDashboard/dashboard/card'
import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'

export default {
  name: 'RequestOffer',
  components: { OurBenefits, RequestOfferForm, Card },
  mixins: [pageMeta],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      await mxGetMeta(ctx, {
        meta: {
          method: 'static'
        }
      })
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      marina: null,
      startDate: dayjs().day(6).add(7, 'd').toDate(),
      endDate: dayjs().day(6).add(14, 'd').toDate()
    }
  },
  async created () {
    this.marina = 'Request offer page'
    if (this.$route.query?.marina) {
      this.marina = {
        name: this.$route.query.marina
      }
    }
    if (this.$route.query?.date_start) {
      this.startDate = new Date(this.$route.query.date_start)
    } else {
      this.startDate = dayjs().day(6).add(7, 'd').toDate()
    }
    if (this.$route.query?.date_end) {
      this.endDate = new Date(this.$route.query.date_end)
    } else {
      this.endDate = dayjs().day(6).add(14, 'd').toDate()
    }
    await this.$store.dispatch('data/getBoatFormData', { type: null, data: { only: ['getCharterTypes'] } })
  }
}
